"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _util = _interopRequireDefault(require("./util"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable no-restricted-globals */

/**
 * @license
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* globals URL self Util */

/** @typedef {HTMLElementTagNameMap & {[id: string]: HTMLElement}} HTMLElementByTagName */
var DOM =
/*#__PURE__*/
function () {
  /**
   * @param {Document} document
   */
  function DOM(document) {
    _classCallCheck(this, DOM);

    /** @type {Document} */
    this._document = document;
    /** @type {string} */

    this._lighthouseChannel = 'unknown';
  }
  /**
   * @template {string} T
   * @param {T} name
   * @param {string=} className
   * @param {Object<string, (string|undefined)>=} attrs Attribute key/val pairs.
   *     Note: if an attribute key has an undefined value, this method does not
   *     set the attribute on the node.
   * @return {HTMLElementByTagName[T]}
   */


  _createClass(DOM, [{
    key: "createElement",
    value: function createElement(name, className) {
      var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var element = this._document.createElement(name);

      if (className) {
        element.className = className;
      }

      Object.keys(attrs).forEach(function (key) {
        var value = attrs[key];

        if (typeof value !== 'undefined') {
          element.setAttribute(key, value);
        }
      });
      return element;
    }
    /**
     * @return {DocumentFragment}
     */

  }, {
    key: "createFragment",
    value: function createFragment() {
      return this._document.createDocumentFragment();
    }
    /**
     * @template {string} T
     * @param {Element} parentElem
     * @param {T} elementName
     * @param {string=} className
     * @param {Object<string, (string|undefined)>=} attrs Attribute key/val pairs.
     *     Note: if an attribute key has an undefined value, this method does not
     *     set the attribute on the node.
     * @return {HTMLElementByTagName[T]}
     */

  }, {
    key: "createChildOf",
    value: function createChildOf(parentElem, elementName, className, attrs) {
      var element = this.createElement(elementName, className, attrs);
      parentElem.appendChild(element);
      return element;
    }
    /**
     * @param {string} selector
     * @param {ParentNode} context
     * @return {DocumentFragment} A clone of the template content.
     * @throws {Error}
     */

  }, {
    key: "cloneTemplate",
    value: function cloneTemplate(selector, context) {
      var template =
      /** @type {?HTMLTemplateElement} */
      context.querySelector(selector);

      if (!template) {
        throw new Error("Template not found: template".concat(selector));
      }

      var clone = this._document.importNode(template.content, true); // Prevent duplicate styles in the DOM. After a template has been stamped
      // for the first time, remove the clone's styles so they're not re-added.


      if (template.hasAttribute('data-stamped')) {
        this.findAll('style', clone).forEach(function (style) {
          return style.remove();
        });
      }

      template.setAttribute('data-stamped', 'true');
      return clone;
    }
    /**
     * Resets the "stamped" state of the templates.
     */

  }, {
    key: "resetTemplates",
    value: function resetTemplates() {
      this.findAll('template[data-stamped]', this._document).forEach(function (t) {
        t.removeAttribute('data-stamped');
      });
    }
    /**
     * @param {string} text
     * @return {Element}
     */

  }, {
    key: "convertMarkdownLinkSnippets",
    value: function convertMarkdownLinkSnippets(text) {
      var element = this.createElement('span');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _util["default"].splitMarkdownLink(text)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var segment = _step.value;

          if (!segment.isLink) {
            // Plain text segment.
            element.appendChild(this._document.createTextNode(segment.text));
            continue;
          } // Otherwise, append any links found.


          var url = new URL(segment.linkHref);
          var DEVELOPERS_GOOGLE_ORIGIN = 'https://developers.google.com';

          if (url.origin === DEVELOPERS_GOOGLE_ORIGIN) {
            url.searchParams.set('utm_source', 'lighthouse');
            url.searchParams.set('utm_medium', this._lighthouseChannel);
          }

          var a = this.createElement('a');
          a.rel = 'noopener';
          a.target = '_blank';
          a.textContent = segment.text;
          a.href = url.href;
          element.appendChild(a);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return element;
    }
    /**
     * @param {string} markdownText
     * @return {Element}
     */

  }, {
    key: "convertMarkdownCodeSnippets",
    value: function convertMarkdownCodeSnippets(markdownText) {
      var element = this.createElement('span');
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = _util["default"].splitMarkdownCodeSpans(markdownText)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var segment = _step2.value;

          if (segment.isCode) {
            var pre = this.createElement('code');
            pre.textContent = segment.text;
            element.appendChild(pre);
          } else {
            element.appendChild(this._document.createTextNode(segment.text));
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return element;
    }
    /**
     * The channel to use for UTM data when rendering links to the documentation.
     * @param {string} lighthouseChannel
     */

  }, {
    key: "setLighthouseChannel",
    value: function setLighthouseChannel(lighthouseChannel) {
      this._lighthouseChannel = lighthouseChannel;
    }
    /**
     * @return {Document}
     */

  }, {
    key: "document",
    value: function document() {
      return this._document;
    }
    /**
     * TODO(paulirish): import and conditionally apply the DevTools frontend subclasses instead of this
     * @return {boolean}
     */

  }, {
    key: "isDevTools",
    value: function isDevTools() {
      return !!this._document.querySelector('.lh-devtools');
    }
    /**
     * Guaranteed context.querySelector. Always returns an element or throws if
     * nothing matches query.
     * @param {string} query
     * @param {ParentNode} context
     * @return {HTMLElement}
     */

  }, {
    key: "find",
    value: function find(query, context) {
      /** @type {?HTMLElement} */
      var result = context.querySelector(query);

      if (result === null) {
        throw new Error("query ".concat(query, " not found"));
      }

      return result;
    }
    /**
     * Helper for context.querySelectorAll. Returns an Array instead of a NodeList.
     * @param {string} query
     * @param {ParentNode} context
     * @return {Array<HTMLElement>}
     */

  }, {
    key: "findAll",
    value: function findAll(query, context) {
      return Array.from(context.querySelectorAll(query));
    }
  }]);

  return DOM;
}(); // if (typeof module !== 'undefined' && module.exports) {
//   module.exports = DOM;
// } else {
//   self.DOM = DOM;
// }


var _default = DOM;
exports["default"] = _default;